import { render, staticRenderFns } from "./SectionDefinition.vue?vue&type=template&id=2b789423&scoped=true&"
import script from "./SectionDefinition.vue?vue&type=script&lang=js&"
export * from "./SectionDefinition.vue?vue&type=script&lang=js&"
import style0 from "./SectionDefinition.vue?vue&type=style&index=0&id=2b789423&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b789423",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VContainer,VIcon,VToolbar,VToolbarTitle})
